<mat-slide-toggle [formControl]="control"
                  [color]="'primary'"
                  (change)="onChange()"
                  [labelPosition]="'before'">
  {{ label }}
</mat-slide-toggle>
